const descriptorOffline = {
  "app_label": "jobs",
  "model_name": "merchantgroup",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "help_text": null,
      "hidden": true,
      "identifier": true,
      "data_type": "int",
      "search": false,
      "sort": false
    },
    {
      "name": "name",
      "label": "Name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "ellipsis": true,
      "search": true,
      "sort": true
    },
    {
      "name": "exporter_name",
      "label": "Exporter name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "search": true,
      "sort": true
    },
    {
      "name": "show_seed",
      "label": "Show seed",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": true
    },
    {
      "name": "mapping_mode",
      "label": "Mapping Mode",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "name",
      "search": true,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    }
  ],
  "filter_by": [
    {
      name: 'mapping_mode',
      label: 'Mapping Mode',
      api: {
        url_name: 'module-merchant-mappingMode-autocomplete',
        key: 'pk',
        display: 'name',
      }
    }
  ],
  "export_import": {
    "export": {
      "directly": false,
      "url_name": "api:admin:jobs:merchantgroup:export",
      "filter_by": [
        {
          "label": "Export Mode",
          "name": "export_mode",
          "type": "choices",
          "choices": [
            [
              "normal",
              "Normal Export"
            ],
            [
              "initial",
              "Initial Export"
            ]
          ]
        },
        {
          "label": "Export Limit",
          "name": "limit",
          "type": "choices",
          "choices": [
            [
              "all",
              "All Records"
            ],
            [
              "100",
              "100 Records"
            ],
            [
              "500",
              "500 Records"
            ]
          ]
        }
      ]
    },
    "import": {
      "url_name": "api:admin:estimation:exportimportsession:import",
      "allow_initial_data": true,
      "fields": [],
      "example_format_string": "seq,old_sequence,name,exporter_name"
    }
  }
}

export default descriptorOffline